import { render, staticRenderFns } from "./EditTenantCustomer.vue?vue&type=template&id=b6ab0f92&scoped=true&"
import script from "./EditTenantCustomer.vue?vue&type=script&lang=js&"
export * from "./EditTenantCustomer.vue?vue&type=script&lang=js&"
import style0 from "./EditTenantCustomer.vue?vue&type=style&index=0&id=b6ab0f92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ab0f92",
  null
  
)

export default component.exports